import React from 'react'
import { TableHead, TableRow, TableCell } from '@mui/material'
import { format, isSameMonth, setMonth, setYear } from '@e3dc-react/shell/Libs/date'
import { makeStyles } from 'tss-react/mui'
import { TotalMonths } from 'src/Libs/shop/utils/basic-system-fix-flex'

interface BasicSystemTableHeaderProps {
  totalMonths: TotalMonths[]
  existingSystemConfiguratorShippingDate: Date | null
  firstPage: number
  lastPage: number
}

const useStyles = makeStyles()(theme => ({
  tableNoBorder: {
    border: 'none',
  },
  highlightMonth: {
    color: theme.palette.primary.main,
  },
}))

const BasicSystemTableHeader: React.FC<BasicSystemTableHeaderProps> = ({
  totalMonths,
  firstPage,
  lastPage,
  existingSystemConfiguratorShippingDate,
}) => {
  const { classes } = useStyles()
  return (
    <TableHead>
      <TableRow>
        <TableCell className={classes.tableNoBorder} />
        {totalMonths.slice(firstPage, lastPage).map((date, index) => {
          const currentMonthDate = setMonth(setYear(new Date(), Number(date.year)), date.month - 1)

          const isDesired = existingSystemConfiguratorShippingDate && isSameMonth(existingSystemConfiguratorShippingDate, currentMonthDate)

          return (
            <TableCell key={date.month + date.year} align="center" className={`${classes.tableNoBorder} ${isDesired ? classes.highlightMonth : ''}`}>
              {format(currentMonthDate, 'MMM yyyy').replace('.', '')}
            </TableCell>
          )
        })}
        {lastPage === totalMonths.length &&
          Array.from({ length: lastPage - firstPage }).map((_, index) => (
            <TableCell key={firstPage + index} className={classes.tableNoBorder} align="center" />
          ))}
      </TableRow>
    </TableHead>
  )
}

export default BasicSystemTableHeader
